import parselinkheader from 'parse-link-header';
import { getDefaultHeader } from '../services/serviceAPIHelper';
import { trackEvent } from './gaService';
export const getAvailability = async function (opts, isEroski) {
    const tabSelected = JSON.parse(localStorage.getItem('selectedTab'));
    const user = JSON.parse(localStorage.getItem('user'));

    let showOnlyEscapes = false;

    if ( tabSelected.hasOwnProperty('productTypes') && Array.isArray(tabSelected.productTypes)) {
        showOnlyEscapes = tabSelected.productTypes.map(x => x.id).includes('ESC');
    }

    opts.options = {
        language: '01',
        allowRQ: true,
        showPVP: true,
        showPrePay: true,
        showEscapes: true,
        showOnlyEscapes: showOnlyEscapes,
        appreciation: true,
        showOffersTypes: true,
        showSeniorOffers55: true,
        showConceptName: true,
        showSubRegimes: true,
        showRestrictions: true,
    };

    let eventParams = {};
    if(opts.selectedSuggestion){
        eventParams[opts.selectedSuggestion.type && opts.selectedSuggestion.type.name ? opts.selectedSuggestion.type.name : 'hotel'] = opts.selectedSuggestion.formattedName;
    }
    trackEvent('availability_search', eventParams);


    let bodycontent;
    try {
        bodycontent = JSON.stringify(opts);
    } catch (error) {
        throw new Error('Unable to serialize request ' + url);
    }
    let headers;
    try {
        headers = getDefaultHeader(true);
    } catch (error) {
        throw new Error('Unable to init headers request ' + url);
    }
    
    const specialURL = isEroski ? '/eroski' : '';

    let url = `${process.env.REACT_APP_API_URL}availability` + specialURL;
    let response;
    try {
        response = await fetch(url, {
            method: 'POST',
            body: bodycontent,
            headers: headers
        });
    } catch (ee) {
        throw new Error('Unable to process request to: ' + url);
    }

    if (response.ok) {
        return await response.json();
    }
    else {
        let error;
        try {
            error = await response.json();
        } catch (ee) {
            error = new Error('Unable to process request to: ' + url);
        }
        if (error) {
            throw error;
        }
    }
};

export const getAvailabilityDetails = async function (requestCode, page = 0, filter = {}, sort = { 'default': 'asc' }) {
    let encodedFilter = encodeURIComponent(JSON.stringify(filter));
    let encodedSort = encodeURIComponent(JSON.stringify(sort));

    let url = process.env.REACT_APP_API_URL + `availability/${requestCode}/?page=${page}&filters=${encodedFilter}&order=${encodedSort}`;
    let response = await fetch(url, {
        method: 'GET',
        headers: getDefaultHeader(true)
    });

    if (response.ok) {
        let pagination = null;
        try {
            let linkString = response.headers.get('Link');
            pagination = parselinkheader(linkString);
        } catch (error) {
            //a veces no tengo headers.
            console.log(error);
        }
        let result = await response.json();
        result.pagination = pagination;
        return result;
    } else {
        let error = new Error('Error at: ' + url);
        try {
            error = await response.json();
        } catch (ee) {
            error = new Error('Unable to process request to: ' + url);
            error.rootCause = ee;
        }
        if (error) {
            throw error;
        }
    }
};

export const getSpecialDestinations = async function (accountName) {
    const url = `${process.env.REACT_APP_API_URL}specialDestinations/${accountName}`;

    const response = await fetch(url, {
        method: 'GET',
        headers: getDefaultHeader(true)
    });

    if (response.status === 200) {
        return await response.json();
    } else {
        console.error(`there was an error retrieving special destinations from backend: ${response.statusText}`);
        return [];
    }
};

export const getValoration = async function (valoration) {
    let url = process.env.REACT_APP_API_URL + 'valuation/';
    // Data que siempre va igual.
    valoration.options = {
        showCancelationConditions: true,
        showPVP: true,
        allowRQ: true,
        showSeniorOffers55: true,
        showRestrictions: true,
        showPrePay: true,
        showEspecialConditions: true
    };

    let response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(valoration),
        headers: getDefaultHeader(true)
    });
    return await response.json();
};


// WEBPACK FOOTER //
// ./src/services/availabilityService.js